import styled from 'styled-components';

export default styled.div`
position: relative;
background-image: url(${props => `${props.image}`});
background-size: cover;
background-position: center;
width: 100%;
height: 400px;
margin-top:10px;
display: flex;
justify-content: center;
`
